import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContentSection, Secondary, Text } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./content-section-cta.module.css";
export function ContentSectionCta(param) {
    var title = param.title, body = param.body, url = param.url, buttonLabel = param.buttonLabel, _classes = param.classes, classes = _classes === void 0 ? "" : _classes, onClick = param.onClick;
    return /*#__PURE__*/ _jsxs("article", {
        className: cx(styles.article, classes),
        children: [
            /*#__PURE__*/ _jsx(Text, {
                element: "h3",
                fontWeight: "bold",
                fontSize: "l",
                className: styles.articleTitle,
                children: title
            }),
            /*#__PURE__*/ _jsx(ContentSection, {
                classNames: {
                    body: styles.articleBody
                },
                children: body
            }),
            /*#__PURE__*/ _jsx(Secondary, {
                element: "a",
                href: url,
                classNames: {
                    button: styles.articleButton
                },
                onClick: onClick,
                children: buttonLabel
            })
        ]
    });
}
export default ContentSectionCta;
